import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ChooseColumnModalContainer, type ChooseColumnModalContainerProps,
} from './chooseColumnModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ChooseSpreadsheetColumn: ChooseColumnModalContainerProps;
  }
}
modalRenderer.register('ChooseSpreadsheetColumn', ChooseColumnModalContainer);
